export enum LevelOfService {
    DiscountBrokerage = 0,
    FullServiceBrokerage = 1,
    StrategicFinancialAdvisoryService = 2,
}

export const isSfas = (levelOfService: LevelOfService): boolean =>
    levelOfService === LevelOfService.StrategicFinancialAdvisoryService;

export const hasFairValueColumn = (levelOfService: LevelOfService): boolean =>
    levelOfService === LevelOfService.FullServiceBrokerage || isSfas(levelOfService);

export const LevelsOfService = [
    {
        id: LevelOfService.DiscountBrokerage,
        name: 'Discount Brokerage',
        shortName: 'DB',
    },
    {
        id: LevelOfService.FullServiceBrokerage,
        name: 'Full Service Brokerage',
        shortName: 'FSB',
    },
    {
        id: LevelOfService.StrategicFinancialAdvisoryService,
        name: 'Strategic Financial Advisory',
        shortName: 'SFA',
    },
];

export const LevelOfServiceOptions = {
    [LevelOfService.DiscountBrokerage]: 'Discount Brokerage',
    [LevelOfService.FullServiceBrokerage]: 'Full Service Brokerage',
    [LevelOfService.StrategicFinancialAdvisoryService]: 'Strategic Financial Advisory',
}
